// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__thWr5","pagination__link":"Pagination_pagination__link__innVr","active":"Pagination_active__FIUxq"};